import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStructuredAnalysisDocumentsWithData } from '../../common/engine/services/structuredAnalysisService';

export const initialState = {
  loading: false,
  error: null,
  structuredDocuments: [],
};

export const getStructuredDocuments = createAsyncThunk(
  'structuredAnalysisEdit/getStructuredDocuments',
  async (projectId) => {
    const response = await getStructuredAnalysisDocumentsWithData(projectId);
    return response;
  }
);

const structuredAnalysisEditSlice = createSlice({
  name: 'structuredAnalysisEdit',
  initialState,
  reducers: {},
  extraReducers: {
    [getStructuredDocuments.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getStructuredDocuments.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.structuredDocuments = payload;
    },
    [getStructuredDocuments.rejected]: (state, { error }) => {
      state.loading = false;
      state.error = error;
      state.structuredDocuments = [];
    },
  },
});

export const { reducer: structuredAnalysisEditReducer } =
  structuredAnalysisEditSlice;

export const getStructuredAnalysisEdit = (state) =>
  state.structuredAnalysisEdit;
